import React from 'react';

import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

// function useOpenWeather() {
//   const [apiData, setApiData] = useState(null);

//   const apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=47.5584&lon=7.5733&exclude=minutely,hourly&units=metric&appid=${process.env.REACT_APP_API_KEY}`;

//   useEffect(() => {
//     fetch(apiUrl)
//       .then((res) => res.json())
//       .then((data) => {
//         setApiData(data);
//         console.log(data);
//       });
//   }, [apiUrl]);

//   return apiData;
// }

function Chart() {
  // const data = useOpenWeather();

  const data = [
    {
      name: 'Monday',
      low: -10,
      high: -6,
    },
    {
      name: 'Tuesday',
      low: -2,
      high: 6,
    },
    {
      name: 'Wednesday',
      low: -1,
      high: 8,
    },
    {
      name: 'Thursday',
      low: -5,
      high: 10,
    },
    {
      name: 'Friday',
      low: 3,
      high: 12,
    },
    {
      name: 'Saturday',
      low: -2,
      high: 8,
    },
    {
      name: 'Sunday',
      low: -5,
      high: 2,
    },
  ];

  return (
    <>
      <h3 className='text-heading fw-lighter pb-3'>7 Day Temps for Basel</h3>
      <ResponsiveContainer width='70%' height={350} className='chart'>
        <LineChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <XAxis
            dataKey='name'
            axisLine={false}
            tickLine={false}
            className='chart'
          />

          <YAxis
            axisLine={false}
            tickLine={false}
            tickFormatter={(number) => `${number}°C`}
            tickCount={6}
          />
          <CartesianGrid opacity='0.4' strokeDasharray='3 3' />
          <Tooltip />
          <Legend />
          <Line type='monotone' dataKey='high' stroke='#ff6600' />
          <Line type='monotone' dataKey='low' stroke='#0073e6' />
        </LineChart>
      </ResponsiveContainer>
    </>
  );
}

export default Chart;
